export const CHIPS_VIEW_OPTIONS_LIMIT = 6;
